// src/resources/reports/ReportPushNotifications/OriginBreakdown.tsx
//
// "Por tipo de envio" (§4 bloco 2) — uma linha por origem: é o que responde
// "quantas foram campanha, quantas foram envio único" (pedido do usuário no
// brainstorm original). `byOrigin` já vem ordenado pelo backend (sent desc).
import React from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { ORIGIN_CAPTIONS, ORIGIN_LABELS, OriginBreakdownRow, fmtInt, fmtPctSmall } from './types';

const OriginBreakdown = ({ byOrigin }: { byOrigin: OriginBreakdownRow[] }) => (
  <Box sx={{ bgcolor: '#fff', border: '1px solid #e2e8f0', borderRadius: 2, p: 2, mb: 2, overflowX: 'auto' }}>
    <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Por tipo de envio</Typography>
    <Typography sx={{ fontSize: 12, color: '#64748b', mb: 1.5 }}>
      Campanha automática dispara uma vez por cliente que bateu a regra; envio único e recorrente são decisão manual.
    </Typography>
    {!byOrigin.length ? (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        Nenhum envio no período.
      </Typography>
    ) : (
      <Table size="small" sx={{ minWidth: 640 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ bgcolor: '#f8fafc' }}>Tipo de envio</TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>Mensagens</TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>Disparos</TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>Enviadas</TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>
              Confirmação
              <Typography component="div" sx={{ fontSize: 10, fontWeight: 400, color: '#94a3b8' }}>app avisou que recebeu</Typography>
            </TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>
              Leitura
              <Typography component="div" sx={{ fontSize: 10, fontWeight: 400, color: '#94a3b8' }}>tocou na notificação</Typography>
            </TableCell>
            <TableCell align="right" sx={{ bgcolor: '#f8fafc' }}>
              Clique
              <Typography component="div" sx={{ fontSize: 10, fontWeight: 400, color: '#94a3b8' }}>abriu a tela indicada</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {byOrigin.map(row => (
            <TableRow key={row.origin}>
              <TableCell>
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{ORIGIN_LABELS[row.origin]}</Typography>
                <Typography sx={{ fontSize: 10.5, color: '#94a3b8', lineHeight: 1.3 }}>{ORIGIN_CAPTIONS[row.origin]}</Typography>
              </TableCell>
              <TableCell align="right">{fmtInt(row.messages)}</TableCell>
              <TableCell align="right">{fmtInt(row.dispatches)}</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>{fmtInt(row.sent)}</TableCell>
              <TableCell align="right">{fmtPctSmall(row.deliveryRate)}</TableCell>
              <TableCell align="right">{fmtPctSmall(row.readRate)}</TableCell>
              <TableCell align="right">{fmtPctSmall(row.clickRate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )}
  </Box>
);

export default OriginBreakdown;
